// extracted by mini-css-extract-plugin
module.exports = {"root":"ExlyModal_root__36F0g","backdrop":"ExlyModal_backdrop__1K5LK","padded":"ExlyModal_padded__KguCT","desktopModalPaper":"ExlyModal_desktopModalPaper__3rrpK"};